import React from "react";
import { Input, InputAdornment } from "@mui/material";
import SearchIcon from "../../../assets/svg/search.svg";
import { NavSearchInputProps } from "../../../interface/types";

const NavSearchInput: React.FC<NavSearchInputProps> = ({
  placeholder,
  onChange,
  autoFocus,
  value,
  inputStyle={},
  inputAdornmentPosition
}) => {
  const shouldUseDefaultRounded = !inputStyle.borderRadius;
  return (
    <>
      <div className={`flex flex-col !text-[0.8rem]`}>
        <Input
          placeholder={placeholder}
          onChange={onChange}
          autoFocus={autoFocus}
          value={value}
          className={` border-gray-400 border-1 !text-[0.8rem]  ${
          shouldUseDefaultRounded ? "rounded-[10rem]" : ""} w-[17rem]`}
          sx={{
            ...inputStyle,
            "& input": {
              paddingLeft: "6px", // move text + placeholder slightly right
            },
            "& input::placeholder": {
              color: "#282828",
              opacity: 0.7,
              fontWeight: 400,
              fontSize: "0.9rem",
              fontFamily: "Lexend Deca",
              
            },
            fontFamily: "Lexend Deca",
          }}
          disableUnderline
          //   endAdornment={
          //     !iconposition ? (
          //       <InputAdornment position="start">
          //         <SearchIcon sx={{ color: "whitesmoke" }} />
          //       </InputAdornment>
          //     ) : undefined
          //   }
          startAdornment={inputAdornmentPosition !== "end" ?
            <InputAdornment position="end" className="!text-[0.8rem]">
              {/* <SearchIcon
                sx={{
                  color: "black",
                  marginRight: "5px",
                  width: "1.2rem",
                  marginLeft: "3px",
                }}
              /> */}
              <img src={SearchIcon} alt="" className="!mr-[1rem] w-[0.9rem]" />
            </InputAdornment>:undefined
          }
          endAdornment={inputAdornmentPosition == "end" ?
            <InputAdornment position="end" className="!text-[0.8rem]">
              {/* <SearchIcon
                sx={{
                  color: "black",
                  marginRight: "5px",
                  width: "1.2rem",
                  marginLeft: "3px",
                }}
              /> */}
              <img src={SearchIcon} alt="" className="!mr-[1rem] w-[0.9rem]" />
            </InputAdornment>:undefined
          }
        />
      </div>
    </>
  );
};

export default NavSearchInput;
